/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tld_Pricing_FailedInputs */

const id_tld_pricing_failed = /** @type {(inputs: Tld_Pricing_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perubahan gagal disimpan. Coba lagi.`)
};

const en_tld_pricing_failed = /** @type {(inputs: Tld_Pricing_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The change could not be saved. Try again.`)
};

/**
* | output |
* | --- |
* | "The change could not be saved. Try again." |
*
* @param {Tld_Pricing_FailedInputs} inputs
* @param {{ locale?: "id" | "en" }} options
* @returns {LocalizedString}
*/
export const tld_pricing_failed = /** @type {((inputs?: Tld_Pricing_FailedInputs, options?: { locale?: "id" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tld_Pricing_FailedInputs, { locale?: "id" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tld_pricing_failed(inputs)
	return id_tld_pricing_failed(inputs)
});